import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4811dd41"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  id: "placeholder",
  ref: "placeholder"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-image__error"
}, "No content", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.isZeroSized ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "placeholder", {}, () => [_hoisted_2], true)], 512)) : _renderSlot(_ctx.$slots, "default", {
    key: 1
  }, undefined, true);
}